import React from 'react'
import SpotifyNowPlaying from "../components/SpotifyNowPlaying";

export default function Contact() {
  return (
    <>
      <div className="">

      </div>

      {/* Contact Form */}
      <section className="w-full flex flex-col justify-start p-[0.4rem] mt-10">
        <h2 className="mb-4">Send me a message ~ 📨</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <form className="flex flex-col gap-4 max-w-md" action="/" method="GET">
            <input
              type="text"
              placeholder="Name"
              name="name"
              className="bg-transparent border border-stone-800/90 p-2 rounded-md text-zinc-200 placeholder-zinc-500 focus:outline-none focus:border-stone-700 transition-colors duration-300"
            />
            <textarea
              placeholder="Message"
              rows="5"
              name="message"
              className="bg-transparent border border-stone-800/90 p-2 rounded-md text-zinc-200 placeholder-zinc-500 focus:outline-none focus:border-stone-700 transition-colors duration-300"
            ></textarea>
            <button class="px-4 py-2 rounded-md bg-stone-800/80 max-w-max text-sm lg:text-base relative no-underline duration-300 ease-in focus:ring-1 ring-stone-600/30 hover:bg-stone-700/50 border border-stone-600/30 w-full" type="submit"><span>Send</span></button>
          </form>
          <SpotifyNowPlaying />
        </div>
      </section>

      {/* Contact Links */}
      <section className="w-full flex flex-col justify-start p-[0.4rem] mt-16">
        <h2>Find me here ~ 🔎</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-y-12 gap-x-12">
          <div>
            <p className="mb-2 text-zinc-400 font-semibold">GitHub</p>
            <a
              href="https://github.com/Amarjit-Khan"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-400 ease-in-out hover:text-[hsla(32,98%,83%,0.9)]"
            >
              @Amarjit-Khan
            </a>
          </div>
          <div>
            <p className="mb-2 text-zinc-400 font-semibold">HackerRank</p>
            <a
              href="https://www.hackerrank.com/profile/amarjit_khan"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-400 ease-in-out hover:text-[hsla(32,98%,83%,0.9)]"
            >
              @amarjit_khan
            </a>
          </div>
          <div>
            <p className="mb-2 text-zinc-400 font-semibold">LinkedIn</p>
            <a
              href="https://www.linkedin.com/in/amarjit-khan-0b6985233"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-400 ease-in-out hover:text-[hsla(32,98%,83%,0.9)]"
            >
              @Amarjit
            </a>
          </div>
          <div>
            <p className="mb-2 text-zinc-400 font-semibold">Email</p>
            <a
              href="mailto:ashirvadbhushan@gmail.com"
              className="transition-colors duration-400 ease-in-out hover:text-[hsla(32,98%,83%,0.9)]"
            >
              amarjitkhan740@gmail.com
            </a>
          </div>
          <div>
            <p className="mb-2 text-zinc-400 font-semibold">LeetCode</p>
            <a
              href="https://leetcode.com/u/Amarjit_Khan/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-400 ease-in-out hover:text-[hsla(32,98%,83%,0.9)]"
            >
              @Amarjit_Khan
            </a>
          </div>
          <div>
            <p className="mb-2 text-zinc-400 font-semibold">CV</p>
            <a
              href="https://drive.google.com/file/d/1CThi-_FyQBJ9-P27gY-jy5qOceIAEYL_/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-400 ease-in-out hover:text-[hsla(32,98%,83%,0.9)]"
            >
              Amarjit-Khan
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
